(function() {
  'use strict';

  angular.module('component.bulkActions', []);
})();
